import { useQuery } from '@tanstack/react-query';
import { api } from './api';
export interface PurchaseOption { id: string; date: string; units: string; securityId: string; subfolioId: string }
export interface DividendOption { id: string; exDate: string; paymentDate?: string; amount: string; cashAmount?: string; securityId: string; subfolioId: string }
export function useRecordOptions<T>(kind: string, enabled: boolean, securityId?: string, subfolioId?: string) {
  return useQuery({ queryKey: ['record-options', kind, securityId, subfolioId], enabled, queryFn: async () => {
    const all: T[] = [];
    let page = 1;
    while (true) {
      const params = new URLSearchParams({ page: String(page), pageSize: '200' });
      if (securityId) params.set('securityId', securityId);
      if (subfolioId) params.set('subfolioId', subfolioId);
      const result = await api<{ items: T[]; total: number }>(`/records/${kind}?${params}`);
      all.push(...result.items);
      if (!result.items.length || all.length >= result.total) return { items: all };
      page++;
    }
  } });
}
